// extracted by mini-css-extract-plugin
export var logo = "_jq-2";
export var logoWrapper = "_jq-1";
export var strip = "_jq-0";